module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BL-809e727b33bf889f682d6bb10a0d0eb1.png";